export default {
  data: () => ({
      recipients: [
        {
          name: "Pearl Gigibitole",
          title: "Compliance Manager",
          email: "pearl.gigibitole@example.com",
          deliveryStatus: "Delivered",
          readStatus: "Read",
          lastActivity: "July 01, 2025 14:32 PM",
          accuracy: "July 01, 2025 14:30 PM"
        },
        {
          name: "John Doe",
          title: "Risk Officer",
          email: "john.doe@example.com",
          deliveryStatus: "Delivered",
          readStatus: "Read",
          lastActivity: "July 01, 2025 15:45 PM",
          accuracy: "July 01, 2025 14:30 PM"
        },
        {
          name: "Sarah Wilson",
          title: "Sr. Compliance Analyst",
          email: "sarah.wilson@example.com",
          deliveryStatus: "Delivered",
          readStatus: "Unread",
          lastActivity: "July 01, 2025 14:28 PM",
          accuracy: "July 01, 2025 14:30 PM"
        }
      ]
    })
  }
